import { render, staticRenderFns } from "./full.vue?vue&type=template&id=97281438&"
import script from "./full.vue?vue&type=script&lang=js&"
export * from "./full.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97281438')) {
      api.createRecord('97281438', component.options)
    } else {
      api.reload('97281438', component.options)
    }
    module.hot.accept("./full.vue?vue&type=template&id=97281438&", function () {
      api.rerender('97281438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/components/container/full.vue"
export default component.exports